import React, { useRef, useState } from 'react';
import { SlideProps } from '../SlideHandler';
import { Gradient } from '../../../Global/styles';
import { checkImage } from '../../../componentUtils';
import {
	FullBackgroundImg,
	TourLine,
	VTSlideDescription,
	VTSlideInner,
	VTSlideTitle,
	VTSpacer,
	VTTrailTitle,
} from '../virtualTourStyles';

const ImageSlide: React.FC<SlideProps> = ({ point, title }) => {
	const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
	const touchHandledRef = useRef(false);

	const handleDescription = () => {
		setIsDescriptionExpanded(prev => !prev);
	};
	const handleDescriptionClick = (
		event: React.MouseEvent<HTMLElement>,
	) => {
		event.stopPropagation();
		if (touchHandledRef.current) {
			touchHandledRef.current = false;
			return;
		}
		handleDescription();
	};
	const handleDescriptionTouchEnd = (
		event: React.TouchEvent<HTMLElement>,
	) => {
		event.stopPropagation();
		event.preventDefault();
		touchHandledRef.current = true;
		handleDescription();
	};
	const handleDescriptionKeyDown = (
		event: React.KeyboardEvent<HTMLElement>,
	) => {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			handleDescription();
		}
	};

	return (
		<>
			<FullBackgroundImg src={checkImage(point.poi_image)} />
			<Gradient $degs={180} />
			<VTSlideInner>
				{title && <VTTrailTitle>{title}</VTTrailTitle>}
				<VTSlideTitle>{point.title}</VTSlideTitle>
				<VTSpacer />
				{point && (
					<VTSlideDescription
						$expanded={isDescriptionExpanded}
						onClick={handleDescriptionClick}
						onTouchEnd={event => handleDescriptionTouchEnd(event)}
						onKeyDown={event => handleDescriptionKeyDown(event)}
						role="button"
						tabIndex={0}
						aria-expanded={isDescriptionExpanded}>
						<div>{point.short_description}</div>
					</VTSlideDescription>
				)}
			</VTSlideInner>
			<TourLine />
			{/* <ForwardArrow /> */}
		</>
	);
};

export default ImageSlide;
